import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminStoriesEventKeys = {
  ADMIN_STORIES_PAGE_VIEW: "admin-stories-page-view",
  ADMIN_STORY_APPROVE_ATTEMPT: "admin-story-approve-attempt",
  ADMIN_STORY_APPROVE_FAILURE: "admin-story-approve-failure",
  ADMIN_STORY_APPROVE_SUCCESS: "admin-story-approve-success",
  ADMIN_STORY_DELETE_ATTEMPT: "admin-story-delete-attempt",
  ADMIN_STORY_DELETE_FAILURE: "admin-story-delete-failure",
  ADMIN_STORY_DELETE_SUCCESS: "admin-story-delete-success",
  ADMIN_STORY_FILTER_STATUS: "admin-story-filter-status",
  ADMIN_STORY_SEARCH: "admin-story-search",
} as const;

export const AdminStoriesEventCatalog: EventCatalogFromKeys<
  typeof AdminStoriesEventKeys
> = {
  [AdminStoriesEventKeys.ADMIN_STORIES_PAGE_VIEW]: {
    description: "Admin viewed the stories management page",
    eventType: EventType.PAGE_VIEW,
    id: AdminStoriesEventKeys.ADMIN_STORIES_PAGE_VIEW,
  },
  [AdminStoriesEventKeys.ADMIN_STORY_APPROVE_ATTEMPT]: {
    description: "Admin attempted to approve a story",
    eventType: EventType.INTERACTION,
    id: AdminStoriesEventKeys.ADMIN_STORY_APPROVE_ATTEMPT,
  },
  [AdminStoriesEventKeys.ADMIN_STORY_APPROVE_FAILURE]: {
    description: "Admin failed to approve a story",
    eventType: EventType.ERROR,
    id: AdminStoriesEventKeys.ADMIN_STORY_APPROVE_FAILURE,
  },
  [AdminStoriesEventKeys.ADMIN_STORY_APPROVE_SUCCESS]: {
    description: "Admin successfully approved a story",
    eventType: EventType.INTERACTION,
    id: AdminStoriesEventKeys.ADMIN_STORY_APPROVE_SUCCESS,
  },
  [AdminStoriesEventKeys.ADMIN_STORY_DELETE_ATTEMPT]: {
    description: "Admin attempted to delete a story",
    eventType: EventType.INTERACTION,
    id: AdminStoriesEventKeys.ADMIN_STORY_DELETE_ATTEMPT,
  },
  [AdminStoriesEventKeys.ADMIN_STORY_DELETE_FAILURE]: {
    description: "Admin failed to delete a story",
    eventType: EventType.ERROR,
    id: AdminStoriesEventKeys.ADMIN_STORY_DELETE_FAILURE,
  },
  [AdminStoriesEventKeys.ADMIN_STORY_DELETE_SUCCESS]: {
    description: "Admin successfully deleted a story",
    eventType: EventType.INTERACTION,
    id: AdminStoriesEventKeys.ADMIN_STORY_DELETE_SUCCESS,
  },
  [AdminStoriesEventKeys.ADMIN_STORY_FILTER_STATUS]: {
    description: "Admin filtered stories by status",
    eventType: EventType.FILTER,
    id: AdminStoriesEventKeys.ADMIN_STORY_FILTER_STATUS,
  },
  [AdminStoriesEventKeys.ADMIN_STORY_SEARCH]: {
    description: "Admin searched for a specific story",
    eventType: EventType.FILTER,
    id: AdminStoriesEventKeys.ADMIN_STORY_SEARCH,
  },
};
